import { render, staticRenderFns } from "./ToKingsunTeacherDialog.vue?vue&type=template&id=a3bae8cc&scoped=true"
import script from "./ToKingsunTeacherDialog.vue?vue&type=script&lang=js"
export * from "./ToKingsunTeacherDialog.vue?vue&type=script&lang=js"
import style0 from "./ToKingsunTeacherDialog.vue?vue&type=style&index=0&id=a3bae8cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bae8cc",
  null
  
)

export default component.exports